import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import 'prop-types';
import styled, { css } from '@xstyled/styled-components';
import { th } from '@xstyled/system';
import { StyledIcon } from '@trybeapp/ui.icon';
import { system } from '@trybeapp/ui.system';
import { overflowEllipsis, getMax, wrapChildren, centerContent } from '@trybeapp/ui.utilities';
import { XIcon } from '@heroicons/react/solid';

var _excluded = ["children", "onRemove", "size", "variant"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var shapeStyles = function shapeStyles(size, width, height, shape) {
  if (shape === void 0) {
    shape = 'square';
  }
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 0;\n  ", "\n  ", ";\n"])), th("tags.shape." + size), (width || height) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      width: ", ";\n      height: ", ";\n    "])), getMax(width || 0, height), getMax(width || 0, height)), shape === 'circle' && 'border-radius: 50%');
};
var StyledTag = /*#__PURE__*/styled.div(function (_ref) {
  var hasAction = _ref.hasAction,
    height = _ref.height,
    length = _ref.length,
    shape = _ref.shape,
    size = _ref.size,
    variant = _ref.variant,
    width = _ref.width;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", "\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: md;\n    line-height: initial; /* avoid cropped font */\n    ", "\n    ", ";\n    ", "\n    ", ";\n    max-width: 100%;\n\n    > *:not(:last-child) {\n      margin-right: md;\n    }\n\n    > *:not(:only-child) {\n      ", ":last-child {\n        opacity: 1;\n        transition: opacity ", ";\n        cursor: pointer;\n\n        &:hover {\n          opacity: 0.6;\n        }\n      }\n    }\n  "])), th('tags.default'), th("tags.variants." + variant), th("tags.sizes." + size), overflowEllipsis, system, !shape && length !== 1 && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n        span,\n        p {\n          ", "\n        }\n      "])), overflowEllipsis), (shape || length === 1) && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n        justify-content: center;\n        ", ";\n      "])), shapeStyles(size, width, height, shape)), /* sc-selector */StyledIcon, th.transition('medium'));
});
var ActionIcon = /*#__PURE__*/styled.div(function (_ref2) {
  var size = _ref2.size;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    ", ";\n    top: 0;\n    bottom: 0;\n    right: 0;\n    padding: 0;\n    margin-left: sm;\n    ", ";\n  "])), th("tags.sizes." + size), centerContent);
});
var Tag = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    onRemove = _ref3.onRemove,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'md' : _ref3$size,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'default' : _ref3$variant,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  var content = wrapChildren(children);
  // get size children for int and string
  var childrenLength = !!(children || children === 0) && ['number', 'string'].includes(typeof children) && children.toString().length;
  return /*#__PURE__*/React.createElement(StyledTag, _extends({
    hasAction: !!onRemove,
    length: childrenLength,
    ref: ref,
    role: "listitem",
    size: size,
    variant: variant
  }, rest), content, !!onRemove && /*#__PURE__*/React.createElement(ActionIcon, {
    size: size
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: "w-4 h-4 inline-block",
    onClick: onRemove,
    alt: "remove"
  })));
});
Tag.displayName = 'Tag';

export { StyledTag, Tag };
